import React from "react"
import { graphql } from "gatsby"

import Link from "../components/link"
import Layout from "../components/layout"
import EventTitle from "../components/eventTitle"
import SpeakerName from "../components/speakerName"
import SpeakerCard from "../components/speakerCard"
import RenderHtml from "../components/renderHtml"

import style from "./speaker.module.css"

export default ({ data }) => {
	const speaker = data.markdownRemark
	return (
		<Layout
			meta={{
				title: speaker.frontmatter.name,
				description: `${
					speaker.frontmatter.name
				} speaks at Accento, an amazing Java/JavaScript conference in Karlsruhe, Germany.`,
				keywords: `${speaker.frontmatter.name} Karlsruhe`,
				path: speaker.fields.path,
				socialImage: speaker.frontmatter.card,
			}}
		>
			<div>
				<h1>
					<SpeakerName speaker={speaker} showSocial />
				</h1>
				<SpeakerCard
					speakerSlug={speaker.frontmatter.slug}
					size="large"
					className={style.image}
				/>
				<RenderHtml withAst={speaker} />
			</div>
			{talkList(speaker)}
			{trainingList(speaker)}
		</Layout>
	)
}

function talkList(speaker) {
	return eventList("Talk", "Talks", speaker.frontmatter.talks)
}

function trainingList(speaker) {
	return eventList("Training", "Trainings", speaker.frontmatter.trainings)
}

function eventList(typeSingular, typePlural, events) {
	if (!events || events.length === 0) return

	if (events.length === 1)
		return (
			<div>
				<h2>{typeSingular}</h2>
				{event(events[0])}
			</div>
		)

	return (
		<div>
			<h2>{typePlural}</h2>
			{events.map(event)}
		</div>
	)
}

function event(event) {
	return (
		<React.Fragment>
			<h3 className={style.eventTitle}>
				<EventTitle event={event} linkTitle />
			</h3>
			<p className={style.eventTeaser}>
				{event.frontmatter.excerpt} <Link to={event.fields.path}>More...</Link>
			</p>
		</React.Fragment>
	)
}

export const query = graphql`
	query($slug: String!) {
		markdownRemark(frontmatter: { slug: { eq: $slug } }) {
			htmlAst
			fields {
				path
			}
			frontmatter {
				name
				slug
				card
				...Social
				talks {
					fields {
						path
					}
					frontmatter {
						title
						excerpt
						language
					}
				}
				trainings {
					fields {
						path
					}
					frontmatter {
						title
						excerpt
						language
					}
				}
			}
		}
	}
`
